import React, { Component } from "react";
import { connect } from "react-redux";
import {
  retrieveEmployes,
  findEmployesByTitle,
  deleteAllEmployes,
} from "../actions/employe";
import { Link } from "react-router-dom";

class EmployesList extends Component {
  constructor(props) {
    super(props);
    this.onChangeSearchNom = this.onChangeSearchNom.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.setActiveEmploye = this.setActiveEmploye.bind(this);
    this.findByNom = this.findByNom.bind(this);
    this.removeAllEmployes = this.removeAllEmployes.bind(this);

    this.state = {
      currentEmploye: null,
      currentIndex: -1,
      searchNom: "",
    };
  }

  componentDidMount() {
    this.props.retrieveEmployes();

  }

  onChangeSearchNom(e) {
    const searchNom = e.target.value;

    this.setState({
      searchNom: searchNom,
    });
  }

  refreshData() {
    this.setState({
      currentEmploye: null,
      currentIndex: -1,
    });
  }

  setActiveEmploye(employe, index) {
    this.setState({
      currentEmploye: employe,
      currentIndex: index,
    });
  }

  removeAllEmployes() {
    this.props
      .deleteAllEmployes()
      .then((response) => {
        console.log(response);
        this.refreshData();
      })
      .catch((e) => {
        console.log(e);
      });
  }

  findByNom() {
    this.refreshData();

    this.props.findEmployesByTitle(this.state.searchNom);
  }

  render() {
    const { searchNom, currentEmploye, currentIndex } = this.state;
    const { employes } = this.props;


    return (
      <div className="list row">
        <div className="col-md-8">
          <div className="input-group mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Rechercher un employé"
              value={searchNom}
              onChange={this.onChangeSearchNom}
            />

            <div className="input-group-append">
              <button
                className="btn btn-outline-secondary"
                type="button"
                onClick={this.findByNom}
              >
                Rechercher
              </button>

            </div>

          </div>
        </div>
        <div className="col-md-6">
          <h4>Liste des employés</h4>

          <ul className="list-group">

            {employes &&
            employes.map((employe, index) => (

                  <li
                  className={
                    "list-group-item " +
                    (index === currentIndex ? "active" : "")
                  }

                  onClick={() => this.setActiveEmploye(employe)}
                  key={employe.id}

                >
                    <ul> {employe.Nom} {employe.Prenom}
                    </ul>
                    <ul>{employe.Employeur}</ul>
                </li>


              ))}
          </ul>

          <button
            className="m-3 btn btn-sm btn-danger"
            onClick={this.removeAllEmployes}
          >
            Supprimer tous les employés
          </button>
        </div>
        <div className="col-md-6">
          {currentEmploye ? (
            <div>
              <h4>Employé</h4>
              <div>
                <label>
                  <strong>Nom:</strong>
                </label>{" "}
                {currentEmploye.Nom}
              </div>
              <div>
                <label>
                  <strong>Status:</strong>
                </label>{" "}
                {currentEmploye.published ? "Published" : "Pending"}
              </div>

              <Link
                to={"/employes/" + currentEmploye.id}
                className="badge badge-warning"
              >
                Editer
              </Link>
            </div>
          ) : (
            <div>
              <br />
              <p>Cliquez sur un employé ou  </p>
              <p>  <a className="nav-item"
                            href="https://pointage.ansart-tp.com/addemployes" type="button"> Ajouter un employé </a>
              </p>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    employes: state.employes,
  };
};

export default connect(mapStateToProps, {
  retrieveEmployes,
  findEmployesByTitle,
  deleteAllEmployes,
})(EmployesList);
